import { useEffect, useState } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import iconFor from "@/components/site/iconMap";
import api from "@/lib/api";

export default function Industries() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Industries | Labpronics Technologies";
    api.get("/content/industries").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <Layout>
      <PageHero eyebrow="Sectors We Serve" title="Industries" subtitle="We serve Government, PSUs, defence and paramilitary, police, premier research institutions and industry with domain-specific technology infrastructure." image="/generated/govt.jpg" />
      <section className="py-20">
        <div className="container-lp grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((ind, i) => {
            const Icon = iconFor(ind.icon);
            return (
              <Reveal key={ind.id} delay={(i % 3) * 0.08}>
                <div data-testid={`industry-${i}`} className="group bg-white border border-lp-border rounded-sm overflow-hidden hover:border-lp-cyan hover:shadow-[0_20px_40px_-24px_rgba(10,43,110,0.35)] transition-all h-full">
                  <div className="img-zoom h-44 relative">
                    <img src={ind.image} alt={ind.name} loading="lazy" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-lp-blue/30" />
                    <div className="absolute bottom-3 left-3 h-11 w-11 bg-white rounded-sm flex items-center justify-center shadow"><Icon size={22} className="text-lp-blue" /></div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading font-700 text-lp-blue text-xl">{ind.name}</h3>
                    <p className="mt-3 text-sm text-lp-muted leading-relaxed">{ind.description}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </Layout>
  );
}
